export default __webpack_public_path__ + "static/media/whatwedo4.245ef7fc.jpg";